
checkBFSG();

function checkBFSG(){
	
	$.ajax({
		url  : '/services/bfsg.cfm',
		type: 'post',
		data : {
			getportal : 1
		},
		success : function(resp) {
			
			thisportal = resp;
			
			if(thisportal == 1){
				
				//var currentURL = window.location.href;
  				//console.log("Current URL with parameters:", currentURL);
				//nobfsg
				
				
				
				
				$.ajax({	
					url  : '/services/bfsg.cfm',
					type: 'post',
					data : {
						getBFSG : 1
					},
					success : function(resp) {

						var resp = eval(resp);

						if(resp){

							for ( i=0; i<resp.length; i++ ){
								var tochange = resp[i][0];
								var tvalue   = resp[i][1];

								console.log('tochange: ' + tochange + ' tvalue: ' + tvalue);

								//Range-Slider Schriftgröße
								if(tochange == 'bfsg_fontsize'){
									$('.bfsg-fontsize').css('font-size',tvalue);
								}
								
								//Range-Slider Zeilenabstand
								if(tochange == 'bfsg_lineheight'){
									$(tochange).css('line-height',tvalue);
								}								

								//Range-Slider Wortabstand
								if(tochange == 'bfsg_wordspacing'){
									$(tochange).css('word-spacing',tvalue);
								}

								//Range-Slider Graustufenbilder
								if(tochange == 'bfsg_blackandwhiteimages'){
									$('img').css('filter',tvalue);
								}

								//Button Bilder ausblenden
								if(tochange == 'bfsg_noimages'){
									$('#bfsg-noimages').attr('rel','bfsg-images');
									$('img').css('opacity','0');
									$('img').css('visibility','hidden');
									$('#bfsg-noimages').toggleClass('bfsgactivebtn');
								}
								
								//Button Bilder einblenden
								if(tochange == 'bfsg_images'){
									$('#bfsg-noimages').attr('rel','bfsg-noimages');
									$('img').css('opacity','unset');
									$('img').css('visibility','visible');
									$('#bfsg-noimages').toggleClass('bfsgactivebtn');
								}

								//Button Schwarz / Weiß
								if(tochange == 'bfsg_blackandwhite'){
									$('#bfsg-blackandwhite').attr('rel','bfsg-color');
									$(tochange).css('filter',tvalue);
									$('#bfsg-blackandwhite').toggleClass('bfsgactivebtn');
									$('html').css('filter',tvalue);
								}
								
								//Button Mit Farben
								if(tochange == 'bfsg_color'){
									$('#bfsg-blackandwhite').attr('rel','bfsg-blackandwhite');
									$(tochange).css('filter',tvalue);
									$('#bfsg-blackandwhite').toggleClass('bfsgactivebtn');
								}
								
								//Button Einfache Schrift
								if(tochange == 'bfsg_easyfont'){
									$('#bfsg-easyfont').toggleClass('bfsgactivebtn');
									$('#bfsg-easyfont').attr('rel','bfsg-normalfont');
									$('.bfsg-fontsize').css('font-family','Raleway');
								}

								//Button Linkhervorhebung
								if(tochange == 'bfsg_showlinks'){
									$('a').css('outline','3px solid #096fd9');
									$('a').css('outline-offset','3px solid #096fd9');
									$('#bfsg-showlinks').toggleClass('bfsgactivebtn');
									$('#bfsg-showlinks').attr('rel','bfsg-normallinks');
								}
								
								//Button Normale Links
								if(tochange == 'bfsg_normallinks'){
									$('a').css('outline','0px solid #096fd9');
									$('a').css('outline-offset','0px solid #096fd9');
									$('#bfsg-normallinks').toggleClass('bfsgactivebtn');
								}

								//Button Lichtbalken
								if(tochange == 'bfsg_highlight'){
									showBFSGHighlight();
								}		

								//Button Lupe
								if(tochange == 'bfsg_lupe'){
									showBFSGLupe();
								}

								//Button Maus-Hervorhebung
								if(tochange == 'bfsg_mousehighlight'){
									$('#bfsg-mousehighlight').toggleClass('bfsgactivebtn');
									toggleInspection();
								}
								
								//Button Keine Animationen
								if(tochange == 'bfsg_noanim'){
									noAnimations();
								}
								
								//Button Maus-Hervorhebung
								if(tochange == 'bfsg_bigmouse'){
									$('#bfsg-bigmouse').toggleClass('bfsgactivebtn');
									toggleBigMouse();
								}
							}	
						}	
					}
				});
				
			}
		}
	});
}



$(document).on("change",".bfsgchange",function() {

	var change = $(this).val();
	var tochange = $(this).attr('rel');

	$.ajax({	
		url  : '/services/bfsg.cfm?changeBFSG',
		type: 'post',
		data : {
			change : change,
			tochange : tochange
		},
		success : function(resp) {

			var resp = eval(resp);

			for ( i=0; i<resp.length; i++ ){
				var tclass = resp[i][0];
				var tcss   = resp[i][1];
				var tvalue = resp[i][2];

				$(tclass).css(tcss,tvalue);

				setBFSGCookie(tochange,tvalue);
				
			}								

		}
	});	

});



$(document).on("click",".bfsgchange_button",function() {

	var tochange = $(this).attr('rel');

	$(this).toggleClass('bfsgactivebtn');


	$.ajax({	
		url  : '/services/bfsg.cfm?changeBFSGButton=' + tochange,
		type: 'post',
		data : {
			tochange : tochange
		},
		success : function(resp) {

			var resp = eval(resp);

			if(resp){

				for ( i=0; i<resp.length; i++ ){
					var tclass = resp[i][0];
					var tcss   = resp[i][1];
					var tvalue = resp[i][2];

					$(tclass).css(tcss,tvalue);

					if($('#' + tochange).hasClass('bfsgactivebtn')){
						setBFSGCookie(tochange,tvalue);
						console.log("cookie an für " + tochange + " mit " + tvalue);
					}else{
						setBFSGCookie(tochange,0);
						console.log("cookie weg für " + tochange + " mit " + tvalue);
					}
				}

				if(tochange == 'bfsg-noimages'){
					$('#bfsg-noimages').attr('rel','bfsg-images');
				}else if(tochange == 'bfsg-images'){
					$('#bfsg-noimages').attr('rel','bfsg-noimages');
				}else if(tochange == 'bfsg-blackandwhite'){
					$('#bfsg-blackandwhite').attr('rel','bfsg-color');
				}else if(tochange == 'bfsg-color'){
					$('#bfsg-blackandwhite').attr('rel','bfsg-blackandwhite');
				}else if(tochange == 'bfsg-showlinks'){
					$('#bfsg-showlinks').attr('rel','bfsg-normallinks');
				}else if(tochange == 'bfsg-normallinks'){
					$('#bfsg-showlinks').attr('rel','bfsg-showlinks');
				}else if(tochange == 'bfsg-noanim'){
					$('#bfsg-noanim').attr('rel','bfsg-withanim');
				}else if(tochange == 'bfsg-withanim'){
					$('#bfsg-noanim').attr('rel','bfsg-noanim');
				}else if(tochange == 'bfsg-easyfont'){
					$('#bfsg-easyfont').attr('rel','bfsg-normalfont');
				}else if(tochange == 'bfsg-normalfont'){
					$('#bfsg-easyfont').attr('rel','bfsg-easyfont');
				}
			}
		}
	});
});



$(document).on("click","#bfsg-noanim",function() {
	noAnimations();
});


function noAnimations(){
	
	$('#bfsg-noanim').toggleClass('bfsgactivebtn');
		
	var owl1 = $('.owl-carousel-aktuell');
	var owl2 = $('.owl-carousel-downloads');
	var owl3 = $('.owl-carousel-events');
			
	if(!$('#bfsg-noanim').hasClass('bfsgactivebtn')){
				
		owl1.trigger('play.owl.autoplay');
		owl2.trigger('play.owl.autoplay');
		owl3.trigger('play.owl.autoplay');
		
		setBFSGCookie('bfsg-noanim',0);
	}else{
		
		$('#carouselHome').carousel({
			interval: false
		});
		
		owl1.trigger('stop.owl.autoplay');
		owl2.trigger('stop.owl.autoplay');
		owl3.trigger('stop.owl.autoplay');
		
		setBFSGCookie('bfsg-noanim',1);
	}
}
	
$(document).on("click","#bfsg-lupe",function() {
	showBFSGLupe();
});


function showBFSGLupe(){	
	
	$('#bfsg-lupe').toggleClass('bfsgactivebtn');
												
	if(!$('#bfsg-lupe').hasClass('bfsgactivebtn')){

		$('#universal-lupe').remove();
		
		setBFSGCookie('bfsg-lupe',0);
	}else{

		$('body').append('<div id="universal-lupe"></div>');

		const lupe = document.getElementById('universal-lupe');

		let mouseX = 0;
		let mouseY = 0;
		let active = false;
		let animationFrame;

		document.addEventListener('mousemove', (e) => {
			const container = e.target.closest('.text-zoom-container');
			if (!container) {
				active = false;
				lupe.style.display = 'none';
				return;
			}

			mouseX = e.pageX;
			mouseY = e.pageY;
			active = true;
		});

		const getContentFromTarget = (el, event) => {
			const tag = el.tagName.toLowerCase();

			if (tag === 'img') {
				return el.alt || el.title || '[Bild]';
			}

			if (['input', 'textarea'].includes(tag)) {
				return el.value;
			}

			if (tag === 'select') {
				return el.options[el.selectedIndex]?.text || '';
			}

			const block = el.closest('p, li, div, span, td, article, section');
			if (block) {
				const text = block.textContent?.trim();
				return text.length > 0 ? text : null;
			}

			return el.innerText?.trim().split(/\s+/)[0] || '';
		};

		const getSentenceAt = (text, pos) => {
			if (!text || pos < 0 || pos >= text.length) return '';

			const sentenceEndRegex = /[.!?。？！]/;

			let start = pos;
				while (start > 0 && !sentenceEndRegex.test(text[start - 1])) {
				start--;
			}

			let end = pos;
				while (end < text.length && !sentenceEndRegex.test(text[end])) {
				end++;
			}

			// Optional: Weiter bis Leerzeichen nach Satzzeichen
			while (end < text.length && /\s/.test(text[end])) {
				end++;
			}

			return text.slice(start, end).trim();
		};


		const updateLoop = () => {
			if (active) {
				const el = document.elementFromPoint(mouseX - window.scrollX, mouseY - window.scrollY);
				if (el) {
					const content = getContentFromTarget(el, { clientX: mouseX, clientY: mouseY });

					if (content) {
						lupe.textContent = content;
						lupe.style.display = 'block';
						lupe.style.left = `${mouseX + 15}px`;
						lupe.style.top = `${mouseY + 15}px`;
					} else {
						lupe.style.display = 'none';
					}
				}
			}

			animationFrame = requestAnimationFrame(updateLoop);
		};

		updateLoop(); // Start der Animation

		setBFSGCookie('bfsg-lupe',1);
	}
}


///////////////////////// Maus-Hervorhebung ////////////////////////////////////
	
$(document).on("click","#bfsg-mousehighlight",function() {
	
	$('#bfsg-mousehighlight').toggleClass('bfsgactivebtn');
												
	if($('#bfsg-mousehighlight').hasClass('bfsgactivebtn')){		
		setBFSGCookie('bfsg-mousehighlight',1);
	}else{
		setBFSGCookie('bfsg-mousehighlight',0);
	}
		
	toggleInspection();
});

let inspectionActive = false;
let lastHoveredElement = null;

const toggleInspection = () => {
  	inspectionActive = !inspectionActive;

	if($('#bfsg-mousehighlight').hasClass('bfsgactivebtn')){
		document.getElementById('bfsg-mousehighlight').addEventListener('click', toggleInspection);
		document.addEventListener('mouseover', handleMouseOver);
		document.addEventListener('mouseout', handleMouseOut);
		document.addEventListener('keydown', handleKeyDown);
	}else{
		document.getElementById('bfsg-mousehighlight').removeEventListener('click', toggleInspection);
		document.removeEventListener('mouseover', handleMouseOver);
		document.removeEventListener('mouseout', handleMouseOut);
		document.removeEventListener('keydown', handleKeyDown);

		if (lastHoveredElement) {
			lastHoveredElement.classList.remove('bfsg-highlight');
			lastHoveredElement = null;
		}
	}
  
	document.body.style.cursor = inspectionActive ? 'crosshair' : 'default';
};

const handleMouseOver = (e) => {
  if (!inspectionActive) return;

  if (lastHoveredElement && lastHoveredElement !== e.target) {
    lastHoveredElement.classList.remove('bfsg-highlight');
  }

  e.target.classList.add('bfsg-highlight');
  lastHoveredElement = e.target;
};

const handleMouseOut = (e) => {
  if (!inspectionActive) return;

  e.target.classList.remove('bfsg-highlight');
};

const handleKeyDown = (e) => {
  if (e.key === 'Escape' && inspectionActive) {
    toggleInspection();
  }
};

///////////////////////// /Maus-Hervorhebung ////////////////////////////////////


////////////////////////// großer Mauszeiger ////////////////////////////////////

$(document).on("click","#bfsg-bigmouse",function() {
	
	$('#bfsg-bigmouse').toggleClass('bfsgactivebtn');
												
	if($('#bfsg-bigmouse').hasClass('bfsgactivebtn')){		
		setBFSGCookie('bfsg-bigmouse',1);
	}else{
		setBFSGCookie('bfsg-bigmouse',0);
	}
		
	toggleBigMouse();
});

let cursorActive = false;

const toggleBigMouse = () => {
  	cursorActive = !cursorActive;

	const bigCursor = document.createElement('div');
	bigCursor.id = 'big-cursor';
	document.body.appendChild(bigCursor);

	const updateCursor = (e) => {
		bigCursor.style.left = `${e.clientX}px`;
		bigCursor.style.top = `${e.clientY}px`;
	};
		
	if($('#bfsg-bigmouse').hasClass('bfsgactivebtn')){
		document.getElementById('bfsg-bigmouse').addEventListener('click', toggleBigMouse);
		$('#big-cursor').css('display','block');
		document.body.style.cursor = 'none';
		document.addEventListener('mousemove', updateCursor);
	} else {
		document.getElementById('bfsg-bigmouse').removeEventListener('click', toggleBigMouse);
		$('#big-cursor').css('display','none');
		document.body.style.cursor = '';
		document.removeEventListener('mousemove', updateCursor);		
	}
}

///////////////////////// /großer Mauszeiger ////////////////////////////////////

function setBFSGCookie(tochange,tvalue){
	$.ajax({	
		url  : '/services/bfsg.cfm?setBFSGCookie',
		type: 'post',
		data : {
			tochange 	: tochange,
			tvalue 	: tvalue
		},
		success : function(resp) {
			
		}
	});	
}

/////////////////////////////Lichtbalken////////////////////////////////////

$(document).on("click","#bfsg-highlight",function() {
	showBFSGHighlight();
});

function showBFSGHighlight(){
	
	$('#bfsg-highlight').toggleClass('bfsgactivebtn');

	if(!$('#bfsg-highlight').hasClass('bfsgactivebtn')){
		$('#overlay-top').hide();
		$('#overlay-bottom').hide();

		setBFSGCookie('bfsg-highlight',0);
	}else{

		$('#overlay-top').show();
		$('#overlay-bottom').show();
		const overlayTop = document.getElementById('overlay-top');
		const overlayBottom = document.getElementById('overlay-bottom');

		const HIGHLIGHT_HEIGHT = 200;

		let latestMouseY = window.innerHeight / 2;
		let needsUpdate = false;

		const updateOverlays = () => {
			const topHeight = latestMouseY - HIGHLIGHT_HEIGHT / 2;
			const bottomTop = latestMouseY + HIGHLIGHT_HEIGHT / 2;

			overlayTop.style.top = '0px';
			overlayTop.style.height = `${topHeight}px`;

			overlayBottom.style.top = `${bottomTop}px`;
			overlayBottom.style.height = `${window.innerHeight - bottomTop}px`;

			needsUpdate = false;
		};

		const animationLoop = () => {
			if (needsUpdate) {
				updateOverlays();
			}
			requestAnimationFrame(animationLoop);
		};

		window.addEventListener('mousemove', (e) => {
			latestMouseY = e.clientY;
			needsUpdate = true;
		});

		// Start loop
		requestAnimationFrame(animationLoop);
		
		setBFSGCookie('bfsg-highlight',1);
	}
	
	
}
						
